import './style.scss'

import React from 'react'

import LoadingIcon from '~/assets/images/icons/loading.svg?react'

import { PublicEmptyLegMarketSortType } from '../../application/types'
import { AVAILABLE_GROUP_TITLE } from '../../domain/presentation'
import { PublicEmptyLegResults as PublicEmptyLegPresentation } from '../../domain/types'
import { FilterButton } from '../FilterButton/FilterButton'
import { NoMatchesState } from '../NoMatchesState/NoMatchesState'
import { PublicEmptyLegCard } from '../PublicEmptyLegCard/PublicEmptyLegCard'
import { ResetSearchButton } from '../ResetSearchButton/ResetSearchButton'

type PublicEmptyLegResultsProps = {
    presentation: PublicEmptyLegPresentation
    selectedSort: PublicEmptyLegMarketSortType
    onSortChange: (sort: PublicEmptyLegMarketSortType) => void
    onGetInfo: () => void
    onResetSearch: () => void
    isInitialSearch: boolean
    isLoading?: boolean
}

export const PublicEmptyLegResults = ({
    presentation,
    selectedSort,
    onSortChange,
    onGetInfo,
    onResetSearch,
    isInitialSearch,
    isLoading = false,
}: PublicEmptyLegResultsProps) => {
    if (isLoading) {
        return (
            <section
                className="public-empty-legs__results public-empty-legs__loading"
                aria-busy="true"
                aria-live="polite"
                role="status"
            >
                <LoadingIcon className="public-empty-legs__loading-icon" />
                <span>Loading empty legs...</span>
            </section>
        )
    }

    if (presentation.kind === 'noMatches') {
        return (
            <NoMatchesState
                title={presentation.title}
                description={presentation.description}
                onResetSearch={onResetSearch}
            />
        )
    }

    const showsToolbarReset = !isInitialSearch && presentation.kind === 'results'

    return (
        <section className="public-empty-legs__results">
            <div className={`public-empty-legs__toolbar${showsToolbarReset ? ' public-empty-legs__toolbar--results' : ''}`}>
                <p className="public-empty-legs__market-message">{presentation.message}</p>
            </div>

            {presentation.kind === 'marketEmpty' ? (
                <>
                    <div className="public-empty-legs__group-heading">
                        <h2 className="public-empty-legs__group-title">{AVAILABLE_GROUP_TITLE}</h2>
                        {isInitialSearch && (
                            <FilterButton selectedValue={selectedSort} onChange={onSortChange} />
                        )}
                    </div>
                    <p className="public-empty-legs__empty">{presentation.description}</p>
                </>
            ) : presentation.groups.map((group, groupIndex) => (
                <section className="public-empty-legs__group" key={group.title}>
                    <div className="public-empty-legs__group-heading">
                        <h2 className="public-empty-legs__group-title">{group.title}</h2>
                        {isInitialSearch && group.matchType === 'market' && (
                            <FilterButton selectedValue={selectedSort} onChange={onSortChange} />
                        )}
                        {showsToolbarReset && groupIndex === 0 && (
                            <ResetSearchButton
                                className="public-empty-legs__toolbar-reset"
                                onClick={onResetSearch}
                            />
                        )}
                    </div>
                    <div className="public-empty-legs__list">
                        {group.emptyLegs.map((emptyLeg) => (
                            <PublicEmptyLegCard
                                emptyLeg={emptyLeg}
                                isExactMatch={group.matchType === 'exact'}
                                key={emptyLeg.id}
                                onGetInfo={onGetInfo}
                            />
                        ))}
                    </div>
                </section>
            ))}
        </section>
    )
}
